// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".logoLeftBottom {\n  position: absolute;\n  bottom: 20px;\n  left: 20px;\n  z-index: 0;\n}\n.logoLeftBottom img {\n  height: auto;\n  max-height: 200px;\n  max-width: 300px;\n}\n@media (max-width: 768px) {\n.logoLeftBottom {\n    position: absolute;\n    bottom: 60px;\n    left: 1px;\n    z-index: 0;\n}\n.logoLeftBottom img {\n    height: auto;\n    max-height: 150px;\n    max-width: 200px;\n}\n}", ""]);
// Exports
module.exports = exports;
